export const promote = (config) => ({
    ...config,
    webhookConnectionId: config.webhookConnectionId ?? ''
});
//# sourceMappingURL=webhook-webhook-3-to-4.js.map